import { render } from "./OrderPaymentsPage.vue?vue&type=template&id=01156eff"
import script from "./OrderPaymentsPage.vue?vue&type=script&lang=js"
export * from "./OrderPaymentsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__